import SubscriptionStateApi from '../../../api/SubscriptionStateApi';
import { SUBSCRIPTION_STATES } from '../../../constants/subscription-state';
import featureFlag from '../../../api/featureFlag';

const LOCAL_STORAGE_KEY = 'riseup.onthemapChallenge.2022-1';

const state = {
  eligbleForChallenge: false,
  variant: null,
};

const getters = {
  shouldShowOnTheMapChallenge: state => {
    const popupShown = localStorage.getItem(LOCAL_STORAGE_KEY);
    return !popupShown && state.eligbleForChallenge;
  },
};

const actions = {
  async initOnTheMapChallenge({ commit }) {
    const { state } = await SubscriptionStateApi.fetchSubscriptionState();

    const onTheMapChallengeEnabled = (await featureFlag.getTreatment('onthemap-challenge-2022')) === 'on';
    if (onTheMapChallengeEnabled
      && [SUBSCRIPTION_STATES.TRIAL, SUBSCRIPTION_STATES.FREE, SUBSCRIPTION_STATES.SUBSCRIBED].includes(state)) {
      commit('setEligibleForChallenge', true);
    }
  },
  setPopupClosed() {
    localStorage.setItem(LOCAL_STORAGE_KEY, true);
  },
};

// mutations
const mutations = {
  setEligibleForChallenge(state, isEligible) {
    state.eligbleForChallenge = isEligible;  // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
